// src/admin/media/MediaCard.jsx

import React from 'react';

const formatFileSize = (bytes) => {
  if (!bytes) return 'Unknown';
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

const formatRelativeTime = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffDays = Math.floor((now - date) / 86400000);

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;
  return date.toLocaleDateString();
};

const MediaCard = ({ media, selected, onSelect, onClick }) => {
  const type = media.metadata?.type || 'image';
  const altText = media.metadata?.alt_text;
  const thumbnailUrl = media.urls?.original;

  return (
    <div
      onClick={onClick}
      style={{
        borderRadius: 12,
        overflow: 'hidden',
        cursor: 'pointer',
        border: `2px solid ${selected ? '#6366F1' : '#F1F5F9'}`,
        transition: 'transform 0.2s, box-shadow 0.2s',
        backgroundColor: 'white',
        position: 'relative'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.01)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      {/* Thumbnail */}
      <div style={{ position: 'relative', height: 160, backgroundColor: '#F8FAFC' }}>
        {type === 'image' ? (
          <img
            src={thumbnailUrl}
            alt={altText || media.original_name}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        ) : (
          <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#1E293B',
            color: 'white',
            fontSize: 32
          }}>
            🎬
          </div>
        )}

        {/* Checkbox */}
        <div
          onClick={(e) => {
            e.stopPropagation();
            onSelect();
          }}
          style={{
            position: 'absolute',
            top: 8,
            left: 8,
            width: 24,
            height: 24,
            borderRadius: 6,
            backgroundColor: selected ? '#6366F1' : 'rgba(255,255,255,0.95)',
            border: selected ? 'none' : '2px solid #CBD5E1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
        >
          {selected && (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.5 3.5L5.5 9.5L2.5 6.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>

        {/* Type Badge */}
        <div style={{
          position: 'absolute',
          top: 8,
          right: 8,
          padding: '4px 8px',
          backgroundColor: 'rgba(0,0,0,0.75)',
          color: 'white',
          borderRadius: 6,
          fontSize: 10,
          fontWeight: 600,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          backdropFilter: 'blur(4px)'
        }}>
          {type === 'image' ? '📷 IMG' : '🎬 VID'}
        </div>
      </div>

      {/* Footer */}
      <div style={{ padding: 12, backgroundColor: 'white' }}>
        <div style={{
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 6,
          color: '#0F172A',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontFamily: "'Plus Jakarta Sans', sans-serif"
        }}>
          {altText || media.original_name || `Media #${media.id}`}
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: 11,
          color: '#64748B',
          fontFamily: "'Plus Jakarta Sans', sans-serif"
        }}>
          <span>{formatFileSize(media.file_size)}</span>
          <span>{formatRelativeTime(media.created_at)}</span>
        </div>
      </div>
    </div>
  );
};

export default MediaCard;